import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "VoteDown.svg",
  "use": "VoteDown.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"VoteDown.svg\"><path d=\"M52.5934,31.2569l-19.01,23.9844a2.0016,2.0016,0,0,1-3.1368,0l-19.01-23.9844a2,2,0,0,1,1.5685-3.2413H22V14a2,2,0,0,1,2-2H40a2,2,0,0,1,2,2V28.0156h9.0249A2,2,0,0,1,52.5934,31.2569Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol